<template>
  <div class="participating-products-page py-5">
    <div class="container text-center">
      <h1 class="mb-5 fw-bold" v-html="$t('ParticipatingProducts.Headline')"></h1>

      <div class="row g-4 justify-content-center">
        <!-- Product 1 -->
        <div class="col-12 col-sm-6 col-md-3">
          <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/product1.png"
            :alt="$t('ParticipatingProducts.Products[0].name')" class="img-fluid mb-3">
          <div class="fw-bold fs-6 px-2" v-html="$t('ParticipatingProducts.Products[0].name')"></div>
        </div>
        <!-- Product 2 -->
        <div class="col-12 col-sm-6 col-md-3">
          <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/product2.png"
            :alt="$t('ParticipatingProducts.Products[1].name')" class="img-fluid mb-3">
          <div class="fw-bold fs-6 px-2" v-html="$t('ParticipatingProducts.Products[1].name')"></div>
        </div>
        <!-- Product 3 -->
        <div class="col-12 col-sm-6 col-md-3">
          <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/product3.png"
            :alt="$t('ParticipatingProducts.Products[2].name')" class="img-fluid mb-3">
          <div class="fw-bold fs-6 px-2" v-html="$t('ParticipatingProducts.Products[2].name')"></div>
        </div>
        <!-- Product 4 -->
        <div class="col-12 col-sm-6 col-md-3">
          <img src="https://snippcheck.blob.core.windows.net/files/WKKC_2008807_CAWalmart_GWP/product4.png"
            :alt="$t('ParticipatingProducts.Products[3].name')" class="img-fluid mb-3">
          <div class="fw-bold fs-6 px-2" v-html="$t('ParticipatingProducts.Products[3].name')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ParticipatingProducts"
}
</script>
